import { cn } from '../../utils/classNames';

const baseClasses =
    'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 ' +
    'text-[0.6875rem] font-bold uppercase tracking-[0.08em] whitespace-nowrap';

const toneClasses = {
    neutral: 'bg-surface-muted text-body',
    primary: 'bg-primary-surface text-primary',
    info: 'bg-primary-surface text-primary',
    success: 'bg-success-surface text-success',
    warning: 'bg-warning-surface text-warning',
    danger: 'bg-danger-surface text-danger',
    muted: 'bg-surface-muted text-subtle',
    onDark: 'bg-white/15 text-white border border-white/25',
};

const PreviewBadge = ({ tone = 'neutral', children, className }) => (
    <span className={cn(baseClasses, toneClasses[tone] || toneClasses.neutral, className)}>{children}</span>
);

export default PreviewBadge;
